export const intentQueryKeys = {
    names: (agentId: number) => ["intent-name", "agent", agentId],
    intents: (agentId: number, skillId?: number) => ["intent", "agent", agentId, "skill", skillId],
    intentsAll: (agentId: number) => ["intent", "agent", agentId]
} as const;
